import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';

const EditButton = ({ basePath = '', record = {} }) => {
	if ( ['new'].indexOf(record.fields.status) === -1 ) {
		return null
	}
	return (
	    <IconButton
			containerElement={<Link to={`${basePath}/${record.id}`} />}
	        style={{ overflow: 'inherit' }}
	    >
	        <ContentCreate color="#0277bd" />
	    </IconButton>
	);
}

EditButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

EditButton.defaultProps = {
    style: { padding: 0 },
};

export default EditButton;



// WEBPACK FOOTER //
// ./src/DCAccount/EditButton.js